module.exports = __webpack_public_path__ + "img/symbol_6.bd0e7194.png";